import type { PublicCatalogItem } from "@/types";

export const UNCATEGORIZED_KEY = "sin-categoria";
export const UNCATEGORIZED_LABEL = "Sin categoría";

export interface CatalogGroup {
  key: string;
  name: string;
  items: PublicCatalogItem[];
}

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Agrupa los productos por categoría, dejando "Sin categoría" siempre al final. */
export function buildGroups(items: PublicCatalogItem[]): CatalogGroup[] {
  const map = new Map<string, CatalogGroup>();

  items.forEach((item) => {
    const name = item.category_name?.trim() || UNCATEGORIZED_LABEL;
    const key = item.category_name ? slugify(name) || UNCATEGORIZED_KEY : UNCATEGORIZED_KEY;
    const bucket = map.get(key) ?? { key, name, items: [] };
    bucket.items.push(item);
    map.set(key, bucket);
  });

  return Array.from(map.values()).sort((a, b) => {
    if (a.key === UNCATEGORIZED_KEY) return 1;
    if (b.key === UNCATEGORIZED_KEY) return -1;
    return a.name.localeCompare(b.name, "es");
  });
}

export function normalizePhone(value: string | null | undefined): string {
  return (value ?? "").replace(/\D/g, "");
}

export function buildWhatsappUrl(number: string | null | undefined, message: string): string {
  const digits = normalizePhone(number);
  if (!digits) return "";
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}